export const URLS = {
  ShortApply: '/short-apply',
};
